<template>
	<div>
		<h1>Academy Plan</h1>
		<InputSrTableCustom
			v-model="table"
			:titlePageAuthors="Authors"
			@authChangeHandler="authorHandler"
		></InputSrTableCustom>
	</div>
</template>
<script>
import InputSrTableCustom from "@/components/InputSrTableCustom.vue";
export default {
	components: {
		InputSrTableCustom
	},
	computed: {
		table() {
			//return this.checkAuthorSelection(this.$tera.project.academyWizard.planTable);
			return this.authorHandler(-1, null, this.$tera.project.academyWizard.planTable);
		},
		Authors() {
			let da = [];
			if (
				//check if authors are initialized
				this.$tera.project.author != undefined &&
				this.$tera.project.acknowledgements != undefined
			) {
				da = [...this.$tera.project.author, ...this.$tera.project.acknowledgements];
				da=this.checkUnion(da.map(el => {
				    return { label: el };
			    }));
			};
			console.log("daaa:"+JSON.stringify(da));
			return da;
		}
	},
	methods: {
		authorHandler(ifadd,row,event){
			if(row!=null){
				this.authorModify(ifadd,row,event);
			}else{
				if(event!=undefined){
					return this.checkAuthorSelection(event);
				}
			}
			return this.$tera.project.academyWizard.planTable;
		},
		checkUnion(U) {
			if (U.length > 0) {
				for (var i = 0; i < U.length; i++) {
					for (var j = i + 1; j < U.length; j++) {
						if (U[i].label == U[j].label) {
							U.splice(j, 1);
							j--;
						}
					}
				}
			}
			return U;
		},
		checkAuthorSelection(table) {
			//console.log("defaults:" + JSON.stringify(table));
			table.rows.forEach(el => {
				if (
					el.tasks == "Design systematic search strategy" ||
					el.tasks == "Run systematic search strings" ||
					el.tasks == "Deduplicate results"
				) {
					if (this.$tera.project.searchStrategyAuthors != null) {
						el.peopleInvolved=this.$tera.project.searchStrategyAuthors;
					}
				}
				if (
					el.tasks == "Citation search" &&
					this.$tera.project.conductSSearchAuthors != null
				) {
					/*el.peopleInvolved = [
						...this.$tera.project.conductSSearchAuthors,
						...el.peopleInvolved
					];
					this.checkUnion(el.peopleInvolved);*/
					el.peopleInvolved=this.$tera.project.conductSSearchAuthors;
				}
				if (
					el.tasks == "Screen abstracts" &&
					this.$tera.project.titleAbstractScreeners != null
				) {
					el.peopleInvolved=this.$tera.project.titleAbstractScreeners;
				}
				if (
					el.tasks == "Obtain full text" &&
					this.$tera.project.fullTextRetrivalAuthor != null
				) {
					el.peopleInvolved=this.$tera.project.fullTextRetrivalAuthor;
				}
				if (
					el.tasks == "Screen full text" &&
					this.$tera.project.fullTextScreeners != null
				) {
					el.peopleInvolved=this.$tera.project.fullTextScreeners;
				}
				if (
					el.tasks == "Screen trial registries" &&
					this.$tera.project.screenTrialRegisPeople != null
				) {
					el.peopleInvolved=this.$tera.project.screenTrialRegisPeople;
				}
				
				if (
					el.tasks == "Screen citation analysis" &&
					this.$tera.project.screenCitationSearchPeople != null
				) {
					el.peopleInvolved=this.$tera.project.screenCitationSearchPeople;
				}
				if (
					el.tasks == "Extract data" &&
					this.$tera.project.extractionAuthors != null
				) {
					el.peopleInvolved=this.$tera.project.extractionAuthors;
				}
				if (
					el.tasks == "Risk of Bias assessment" &&
					this.$tera.project.assessedRobAuthors != null
				) {
					el.peopleInvolved=this.$tera.project.assessedRobAuthors;
				}
			});
			return table;
		},
		authorModify(ifadd, row, event) {
			if (
				row.tasks.includes("Design systematic search strategy") ||
				row.tasks.includes("Run systematic search strings") ||
				row.tasks.includes("Deduplicate results")
			) {
				if (ifadd == 1) {
					this.$tera.project.searchStrategyAuthors.splice(
						this.$tera.project.searchStrategyAuthors.length,
						0,
						event
					);
				} else {
					this.$tera.project.searchStrategyAuthors.splice(
						this.$tera.project.searchStrategyAuthors.indexOf(event),
						event
					);
				}
			}
			if (row.tasks.includes("Citation search")) {
				if (ifadd == 1) {
					this.$tera.project.conductSSearchAuthors.push(event);
				} else {
					this.$tera.project.conductSSearchAuthors.splice(
						this.$tera.project.conductSSearchAuthors.indexOf(event),
						event
					);
				}
			}
			if (row.tasks.includes("Screen abstracts")) {
				if (ifadd == 1) {
					this.$tera.project.titleAbstractScreeners.push(event);
				} else {
					this.$tera.project.titleAbstractScreeners.splice(
						this.$tera.project.titleAbstractScreeners.indexOf(event),
						event
					);
				}
			}
			if (row.tasks.includes("Obtain full text")) {
				if (ifadd == 1) {
					this.$tera.project.fullTextRetrivalAuthor.push(event);
				} else {
					this.$tera.project.fullTextRetrivalAuthor.splice(
						this.$tera.project.fullTextRetrivalAuthor.indexOf(event),
						event
					);
				}
			}
			if (row.tasks.includes("Screen full text")) {
				if (ifadd == 1) {
					this.$tera.project.fullTextScreeners.push(event);
				} else {
					this.$tera.project.fullTextScreeners.splice(
						this.$tera.project.fullTextScreeners.indexOf(event),
						event
					);
				}
			}
			if (row.tasks.includes("Screen trial registries")) {
				if (ifadd == 1) {
					this.$tera.project.screenTrialRegisPeople.push(event);
				} else {
					this.$tera.project.screenTrialRegisPeople.splice(
						this.$tera.project.screenTrialRegisPeople.indexOf(event),
						event
					);
				}
			}
			if (row.tasks.includes("Screen citation analysis")) {
				if (ifadd == 1) {
					this.$tera.project.screenCitationSearchPeople.push(event);
				} else {
					this.$tera.project.screenCitationSearchPeople.splice(
						this.$tera.project.screenCitationSearchPeople.indexOf(event),
						event
					);
				}
			}
			if (row.tasks.includes("Extract data")) {
				if (ifadd == 1) {
					this.$tera.project.extractionAuthors.push(event);
				} else {
					this.$tera.project.extractionAuthors.splice(
						this.$tera.project.extractionAuthors.indexOf(event),
						event
					);
				}
			}
			if (row.tasks.includes("Risk of Bias assessment")) {
				if (ifadd == 1) {
					this.$tera.project.assessedRobAuthors.push(event);
				} else {
					this.$tera.project.assessedRobAuthors.splice(
						this.$tera.project.assessedRobAuthors.indexOf(event),
						event
					);
				}
			}
		},
	}
};
</script>
